import { render, staticRenderFns } from "./LottieSendEmail.vue?vue&type=template&id=15b1c2d8&scoped=true&"
import script from "./LottieSendEmail.vue?vue&type=script&lang=js&"
export * from "./LottieSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1c2d8",
  null
  
)

export default component.exports